// extracted by mini-css-extract-plugin
export var fadeEffect = "NavLogo-module--fadeEffect--04a6f";
export var root = "NavLogo-module--root--0b3f3";